// AnalyticsCards.jsx
import React from "react";

const AnalyticsCards = ({ analytics }) => {
  const cardData = [
    {
      title: "Issued ",
      data: analytics?.booking,
      bgColor: "bg-gradient-to-br from-blue-50 to-blue-100",
      borderColor: "border-blue-300",
      textColor: "text-blue-700",
      isIssued: true,
    },
    {
      title: "Voids",
      data: analytics?.void,
      bgColor: "bg-gradient-to-br from-red-50 to-red-100",
      borderColor: "border-red-300",
      textColor: "text-red-700",
      isVoid: true,
    },
    {
      title: "Refunds",
      data: analytics?.refund,
      bgColor: "bg-gradient-to-br from-yellow-50 to-yellow-100",
      borderColor: "border-yellow-300",
      textColor: "text-yellow-700",
      penalty: true,
    },
    {
      title: "Exchanges",
      data: analytics?.exchange,
      bgColor: "bg-gradient-to-br from-green-50 to-green-100",
      borderColor: "border-green-300",
      textColor: "text-green-700",
      penalty: true,
      exDiff: true,
    },
    // {
    //   title: "System Fees",
    //   data: analytics?.systemFee,
    //   bgColor: "bg-gradient-to-br from-indigo-50 to-indigo-100",
    //   borderColor: "border-indigo-300",
    //   textColor: "text-indigo-700",
    //   icon: "⚙️",
    // },
    // {
    //   title: "Void Fees",
    //   data: analytics?.voidFee,
    //   bgColor: "bg-gradient-to-br from-pink-50 to-pink-100",
    //   borderColor: "border-pink-300",
    //   textColor: "text-pink-700",
    //   isVoidFee: true,
    // },
    {
      title: "Total Sales",
      data: analytics?.netRevenue,
      bgColor: "bg-gradient-to-br from-teal-50 to-teal-100",
      borderColor: "border-teal-300",
      textColor: "text-teal-700",
      isSummary: true,
    },
  ];

  return (
    <div className="p-2 mx-auto mb-8 bg-gray-50">
      <h1 className="mb-2 text-2xl font-extrabold tracking-tight text-gray-900">
        Analytics Overview
      </h1>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {cardData.map((card, index) => (
          <div
            key={index}
            className={`py-2 px-4 rounded-2xl shadow-md ${card.borderColor} border-1 `}
          >
            <div className="flex justify-between items-center mb-1">
              <h2 className={`text-lg font-bold ${card.textColor}`}>
                {card?.title}
              </h2>

              {!card?.isVoid && (
                <p className={`text-lg font-semibold ${card.textColor}`}>
                  Total: ETB {card?.data?.totalAmount?.toLocaleString() || "0"}
                </p>
              )}
            </div>
            <div className="relative space-y-1 text-sm">
              {!card?.isSummary ? (
                <div className="flex relative flex-col font-semibold">
                  <p className="text-gray-700">
                    <span className="font-medium">Count:</span>{" "}
                    {card?.data?.count || 0}
                  </p>
                  {!card?.penalty &&
                    card?.data?.baseFare > 0 &&
                    card?.data?.baseFare !== undefined && (
                      <p className="text-gray-700">
                        <span className="font-medium">Base Fare:</span> ETB{" "}
                        {card?.data?.baseFare?.toLocaleString() || "0"}
                      </p>
                    )}
                  {card?.data?.totalRefundedAmount > 0 && !card?.isIssued && (
                    <p className="text-gray-700">
                      <span className="font-medium">Refunded:</span> ETB{" "}
                      {card?.data?.totalRefundedAmount?.toLocaleString() || "0"}
                    </p>
                  )}
                  {card?.data?.totalServiceCharge > 0 && (
                    <p className="text-gray-700">
                      <span className="font-medium">Service Charge:</span> ETB{" "}
                      {card?.data?.totalServiceCharge?.toLocaleString() || "0"}
                    </p>
                  )}
                  {card?.penalty && (
                    <>
                      <p className="text-gray-700">
                        <span className="font-medium">Tax:</span> ETB{" "}
                        {card?.data?.totalTax?.toLocaleString() || "0"}
                      </p>
                      <p className="text-gray-700">
                        <span className="font-medium">Penalty:</span> ETB{" "}
                        {card?.data?.totalPenalty?.toLocaleString() || "0"}
                      </p>
                      {card?.exDiff && (
                        <p className="text-gray-700">
                          <span className="font-medium">
                            Exchange Difference:
                          </span>{" "}
                          ETB{" "}
                          {card?.data?.totalExchangeDifference?.toLocaleString() ||
                            "0"}
                        </p>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div className="flex relative flex-col font-semibold">
                  <p className="text-gray-700">
                    <span className="font-medium">Base Fare:</span> ETB{" "}
                    {card?.data?.totalBaseFare?.toLocaleString() || "0"}
                  </p>
                  {card?.data?.totalRefundedAmount > 0 && (
                    <p className="text-gray-700">
                      <span className="font-medium">Refunded:</span> ETB{" "}
                      {card?.data?.totalRefundedAmount?.toLocaleString() || "0"}
                    </p>
                  )}
                  <p className="text-gray-700">
                    <span className="font-medium">Service Charge:</span> ETB{" "}
                    {card?.data?.totalServiceCharge?.toLocaleString() || "0"}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-medium">Void Fee:</span> ETB{" "}
                    {card?.data?.totalVoidFee?.toLocaleString() || "0"}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsCards;
